import React from "react";
import "./SkillLogo.css";

import img1 from '../../assets/logos/1.png';
import img2 from '../../assets/logos/2.png';
import img3 from '../../assets/logos/5.png';
import img4 from '../../assets/logos/4.png';
import img5 from '../../assets/logos/3.png';
import img6 from '../../assets/logos/node.png';
import img7 from '../../assets/logos/fireb.png';
import img8 from '../../assets/logos/15.png';
import img9 from '../../assets/logos/ts.png';


const skills = [

  { name: "Laravel", image: img1, rating: 4.5 },
  { name: "NodeJs", image: img2, rating: 3.5 },
  { name: "Electron", image: img3, rating: 3.5 },
  { name: "VueNative", image: img4, rating: 3.5 },
  { name: "VueNative", image: img5, rating: 3.5 },
  { name: "VueNative", image: img6, rating: 3.5 },
  { name: "VueNative", image: img7, rating: 3.5 },
  { name: "VueNative", image: img8, rating: 3.5 },
  { name: "VueNative", image: img9, rating: 3.5 },
];

const SkillLogo = () => {
  return (
    <section className="section">
      <div className="container">
        {/* Left-side text content */}
        <div className="text-content">
          {/* <h2>My Skills</h2> */}
         <p> As a frontend development, I possess a range of skills that enable me to created visually appealing and responsive user interfaces for websites. Some of the  projects I've mentioned in the section below this one.</p>
        </div>

        {/* Right-side skill boxes */}
        <div className="wall">
          {["", "second", "third", "forth"].map((className, i) => (
            <div key={i} className={`v-boxes ${className}`}>
              {skills.slice(i * 3, i * 3 + 3).map((skill, index) => (
                <div key={index} className="box">
                 
                  <div className="box-face">
                    <div className="box-text">
                      {skill.image ? <img src={skill.image} alt={skill.name} /> : <i className={skill.icon}></i>}
                    </div>
                  </div>
                  <div className="box-back">
                    <div className="box-text">
                    {skill.image ? <img src={skill.image} alt={skill.name} /> : <i className={skill.icon}></i>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        
        </div>
      </div>
    </section>
  );
};

export default SkillLogo;